/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import type {
	ConditionObject,
	IActionForm,
	LabelActionItem,
	IPccRuleFormDynamic,
	IPccRuleFormStatic,
	IFlowInfoForm,
	IResetSMSForm,
} from 'interfaces';
import {generateUUID} from 'utils';

export const defaultFormDataAction = (
	dataFromDb?: Partial<IActionForm>,
): IActionForm => {
	const initializeField = <T>(
		field: ConditionObject<T> | undefined,
		defaultValue: T,
	): ConditionObject<T> => ({
		value: field?.value || defaultValue,
		notChecked: false,
		active: field?.active || false,
	});

	const initializeObject = <T>(field: T | undefined, defaultObject: T): T => ({
		...defaultObject,
		...field,
	});

	return {
		id: dataFromDb?.id ?? `action-${generateUUID()}`,
		hasRuleDynamic: dataFromDb?.hasRuleDynamic ?? false,
		hasRuleStatic: dataFromDb?.hasRuleStatic ?? false,
		hasResetSMS: dataFromDb?.hasResetSMS ?? false,
		authDefQos: {
			_5qi: initializeField(dataFromDb?.authDefQos?._5qi, ''),
			arp: initializeObject(dataFromDb?.authDefQos?.arp, {
				priorityLevel: initializeField(
					dataFromDb?.authDefQos?.arp?.priorityLevel,
					'',
				),
				preemptCap: initializeField(
					dataFromDb?.authDefQos?.arp?.preemptCap,
					'',
				),
				preemptVuln: initializeField(
					dataFromDb?.authDefQos?.arp?.preemptVuln,
					'',
				),
			}),
		},
		authSessAmbr: {
			uplink: initializeField(dataFromDb?.authSessAmbr?.uplink, ''),
			downlink: initializeField(dataFromDb?.authSessAmbr?.downlink, ''),
		},
		chargingCharacteristics: initializeField(
			dataFromDb?.chargingCharacteristics,
			'',
		),
		chargingParameter: {
			online: initializeField(dataFromDb?.chargingParameter?.online, false),
			offline: initializeField(dataFromDb?.chargingParameter?.offline, false),
			chargingInfo: initializeObject(
				dataFromDb?.chargingParameter?.chargingInfo,
				{
					primaryChfAddress: initializeField(
						dataFromDb?.chargingParameter?.chargingInfo?.primaryChfAddress,
						'',
					),
					secondaryChfAddress: initializeField(
						dataFromDb?.chargingParameter?.chargingInfo?.secondaryChfAddress,
						'',
					),
				},
			),
		},
		monitoringKey: initializeField(dataFromDb?.monitoringKey, ''),
		pccRuleDynamic: (dataFromDb?.pccRuleDynamic || [])?.map(rule =>
			defaultRuleDynamicDataAction(rule),
		),
		pccRuleStatic: (dataFromDb?.pccRuleStatic || [])?.map(rule =>
			defaultRuleStaticDataAction(rule),
		),
		qosData: {
			_5qi: initializeField(dataFromDb?.qosData?._5qi, ''),
			maxbrUl: initializeField(dataFromDb?.qosData?.maxbrUl, ''),
			maxbrDl: initializeField(dataFromDb?.qosData?.maxbrDl, ''),
			gbrUl: initializeField(dataFromDb?.qosData?.gbrUl, ''),
			gbrDl: initializeField(dataFromDb?.qosData?.gbrDl, ''),
			arp: initializeObject(dataFromDb?.qosData?.arp, {
				priorityLevel: initializeField(
					dataFromDb?.qosData?.arp?.priorityLevel,
					'',
				),
				preemptCap: initializeField(dataFromDb?.qosData?.arp?.preemptCap, ''),
				preemptVuln: initializeField(dataFromDb?.qosData?.arp?.preemptVuln, ''),
			}),
		},
		resetSMS: (dataFromDb?.resetSMS || [])?.map(resetSMS =>
			defaultResetSMSDataAction(resetSMS),
		),
		sms: initializeField(dataFromDb?.sms, ''),
		terminate: initializeField(dataFromDb?.terminate, false),
	};
};

export const defaultRuleDynamicDataAction = (
	dataFromDb?: Partial<IPccRuleFormDynamic>,
): IPccRuleFormDynamic => {
	const initializeField = <T>(
		field: ConditionObject<T> | undefined,
		defaultValue: T,
	): ConditionObject<T> => ({
		value: field?.value || defaultValue,
		notChecked: false,
		active: field?.active || false,
	});

	const initializeObject = <T>(field: T | undefined, defaultObject: T): T => ({
		...defaultObject,
		...field,
	});

	return {
		id: dataFromDb?.id ?? `pccRule-${generateUUID()}`,
		hasFlowInfo: dataFromDb?.hasFlowInfo ?? false,
		flowInfo: (dataFromDb?.flowInfo || [])?.map(flowIn =>
			defaultFlowInfoDataAction(flowIn),
		),
		precedence: initializeField(dataFromDb?.precedence, ''),
		qosData: initializeObject(dataFromDb?.qosData, {
			_5qi: initializeField(dataFromDb?.qosData?._5qi, ''),
			maxbrUl: initializeField(dataFromDb?.qosData?.maxbrUl, ''),
			maxbrDl: initializeField(dataFromDb?.qosData?.maxbrDl, ''),
			gbrUl: initializeField(dataFromDb?.qosData?.gbrUl, ''),
			gbrDl: initializeField(dataFromDb?.qosData?.gbrDl, ''),
			arp: initializeObject(dataFromDb?.qosData?.arp, {
				priorityLevel: initializeField(
					dataFromDb?.qosData?.arp?.priorityLevel,
					'',
				),
				preemptCap: initializeField(dataFromDb?.qosData?.arp?.preemptCap, ''),
				preemptVuln: initializeField(dataFromDb?.qosData?.arp?.preemptVuln, ''),
			}),
		}),
		chargingData: initializeObject(dataFromDb?.chargingData, {
			chgId: initializeField(dataFromDb?.chargingData?.chgId, ''),
			offline: initializeField(dataFromDb?.chargingData?.offline, false),
			online: initializeField(dataFromDb?.chargingData?.online, false),
			ratingGroup: initializeField(dataFromDb?.chargingData?.ratingGroup, ''),
			serviceId: initializeField(dataFromDb?.chargingData?.serviceId, ''),
			reportingLevel: initializeField(
				dataFromDb?.chargingData?.reportingLevel,
				'',
			),
			afChargingIdentifier: initializeField(
				dataFromDb?.chargingData?.afChargingIdentifier,
				'',
			),
		}),
		afSigProtocol: initializeField(dataFromDb?.afSigProtocol, ''),
	};
};

export const defaultFlowInfoDataAction = (
	dataFromDb?: Partial<IFlowInfoForm>,
): IFlowInfoForm => {
	const initializeField = <T>(
		field: ConditionObject<T> | undefined,
		defaultValue: T,
	): ConditionObject<T> => ({
		value: field?.value || defaultValue,
		notChecked: false,
		active: field?.active || false,
	});

	return {
		id: dataFromDb?.id ?? `flowInfo-${generateUUID()}`,
		flowDescription: initializeField(dataFromDb?.flowDescription, ''),
		flowDirection: initializeField(dataFromDb?.flowDirection, ''),
		tosTrafficClass: initializeField(dataFromDb?.tosTrafficClass, ''),
	};
};

export const defaultRuleStaticDataAction = (
	dataFromDb?: Partial<IPccRuleFormStatic>,
): IPccRuleFormStatic => {
	const initializeField = <T>(
		field: ConditionObject<T> | undefined,
		defaultValue: T,
	): ConditionObject<T> => ({
		value: field?.value || defaultValue,
		notChecked: false,
		active: true,
	});

	const initializeObject = <T>(field: T | undefined, defaultObject: T): T => ({
		...defaultObject,
		...field,
	});

	return {
		id: dataFromDb?.id ?? `pccRuleStatic-${generateUUID()}`,
		pccRuleId: initializeObject(dataFromDb?.pccRuleId, {
			pccRuleId: initializeField(dataFromDb?.pccRuleId?.pccRuleId, ''),
			crbn: initializeField(dataFromDb?.pccRuleId?.crbn, false),
		}),
	};
};

export const defaultResetSMSDataAction = (
	dataFromDb?: Partial<IResetSMSForm>,
): IResetSMSForm => {
	const initializeField = <T>(
		field: ConditionObject<T> | undefined,
		defaultValue: T,
	): ConditionObject<T> => ({
		value: field?.value || defaultValue,
		notChecked: false,
		active: true,
	});

	return {
		id: dataFromDb?.id ?? `resetSMS-${generateUUID()}`,
		resetSMS: initializeField(dataFromDb?.resetSMS, ''),
	};
};

export const labelActionsPccRule: LabelActionItem[] = [
	{category: 'Precedence'},
	{
		category: 'QoS Data',
		items: [
			{category: '5qi'},
			{category: 'Max BR Uplink'},
			{category: 'Max BR Downlink'},
			{category: 'Guaranteed BR Uplink'},
			{category: 'Guaranteed BR Downlink'},
			{
				category: 'ARP',
				items: [{category: 'ARP'}],
				scope: ['App', 'Gw'],
			},
		],
		scope: ['App', 'Gw'],
	},
	{
		category: 'Charging Data',
		items: [
			{category: 'Online'},
			{category: 'Offline'},
			{category: 'Rating Group'},
			{category: 'Service Id'},
			{category: 'Af Charging Identifier'},
			{category: 'Reporting Level'},
		],
		scope: ['App', 'Gw'],
	},
	{
		category: 'Flow Information',
		items: [{category: 'Flow'}],
		scope: ['App', 'Gw'],
	},
];

export const labelActions: LabelActionItem[] = [
	{
		category: 'Auth Def QoS',
		items: [
			{category: '5qi'},
			{
				category: 'ARP',
				items: [{category: 'ARP'}],
				scope: ['Gw'],
			},
		],
		scope: ['Gw'],
	},
	{
		category: 'AMBR',
		items: [{category: 'Uplink Bit Rate'}, {category: 'Downlink Bit Rate'}],
		scope: ['Gw'],
	},
	{
		category: 'Charging Parameters',
		items: [
			{category: 'Online'},
			{category: 'Offline'},
			{category: 'Primary Chf Address'},
			{category: 'Secondary Chf Address'},
		],
		scope: ['Gw'],
	},
	{
		category: 'Data',
		items: [{category: 'Monitoring Key'}],
		scope: ['Gw'],
	},
	{
		category: 'Final Actions',
		items: [{category: 'Terminate'}],
		scope: ['Gw'],
	},
	{
		category: 'QoS Data',
		items: [
			{category: '5qi'},
			{category: 'Max BR Uplink'},
			{category: 'Max BR Downlink'},
			{category: 'Guaranteed BR Uplink'},
			{category: 'Guaranteed BR Downlink'},
			{
				category: 'ARP',
				items: [{category: 'ARP'}],
				scope: ['App', 'Gw'],
			},
		],
		scope: ['App'],
	},
	{
		category: 'Reset SMS',
		items: [{category: 'Policy'}],
		scope: ['App', 'Gw'],
	},
	{
		category: 'Special Actions',
		items: [{category: 'Send SMS'}],
		scope: ['App', 'Gw'],
	},
	{
		category: 'Dynamic PCC Rule',
		items: [{category: 'Rule'}],
		scope: ['App', 'Gw'],
	},
	{
		category: 'Static PCC Rule',
		items: [{category: 'Rule'}],
		scope: ['App', 'Gw'],
	},
];

export type TransformedItem = {
	category: string;
	items: TransformedItem[];
	scope?: ('App' | 'Gw')[];
	isVolTE: boolean;
};

export const transformLabelActions = (
	actions: LabelActionItem[],
	typeForm: 'App' | 'Gw',
	isCategoryVolTE: boolean,
): TransformedItem[] => {
	function filterItems(
		items: LabelActionItem[],
		parentScope: ('App' | 'Gw')[],
	): TransformedItem[] {
		return items
			.map(item => {
				if (
					(isCategoryVolTE && item.isVolTE === false) ||
					(!isCategoryVolTE && item.isVolTE === true)
				) {
					return null;
				}

				const effectiveScope = item.scope ?? parentScope;

				if (!effectiveScope.includes(typeForm)) return null;

				const filteredSubItems = item.items
					? filterItems(item.items, effectiveScope)
					: [];

				return {
					category: item.category,
					items: filteredSubItems,
					scope: effectiveScope,
				};
			})
			.filter(Boolean) as TransformedItem[];
	}
	return filterItems(actions, [typeForm]);
};

export const labelToFieldMap: Record<string, keyof IActionForm | string[]> = {
	'Auth Def QoS 5qi': ['authDefQos', '_5qi'],
	'Auth Def QoS ARP ARP': ['authDefQos', 'arp'],
	'AMBR Uplink Bit Rate': ['authSessAmbr', 'uplink'],
	'AMBR Downlink Bit Rate': ['authSessAmbr', 'downlink'],
	'Charging Parameters Online': ['chargingParameter', 'online'],
	'Charging Parameters Offline': ['chargingParameter', 'offline'],
	'Charging Parameters Primary Chf Address': [
		'chargingParameter',
		'chargingInfo',
		'primaryChfAddress',
	],
	'Charging Parameters Secondary Chf Address': [
		'chargingParameter',
		'chargingInfo',
		'secondaryChfAddress',
	],
	'QoS Data 5qi': ['qosData', '_5qi'],
	'QoS Data Max BR Uplink': ['qosData', 'maxbrUl'],
	'QoS Data Max BR Downlink': ['qosData', 'maxbrDl'],
	'QoS Data Guaranteed BR Uplink': ['qosData', 'gbrUl'],
	'QoS Data Guaranteed BR Downlink': ['qosData', 'gbrDl'],
	'QoS Data ARP ARP': ['qosData', 'arp'],
	'Data Monitoring Key': 'monitoringKey',
	'Reset SMS Policy': 'hasResetSMS',
	'Special Actions Send SMS': 'sms',
	'Dynamic PCC Rule Rule': 'hasRuleDynamic',
	'Static PCC Rule Rule': 'hasRuleStatic',
};

export const labelToFieldRuleMap: Record<
	string,
	keyof IPccRuleFormDynamic | string[]
> = {
	Precedence: 'precedence',
	'QoS Data 5qi': ['qosData', '_5qi'],
	'QoS Data Max BR Uplink': ['qosData', 'maxbrUl'],
	'QoS Data Max BR Downlink': ['qosData', 'maxbrDl'],
	'QoS Data Guaranteed BR Uplink': ['qosData', 'gbrUl'],
	'QoS Data Guaranteed BR Downlink': ['qosData', 'gbrDl'],
	'QoS Data ARP ARP': ['qosData', 'arp'],
	'Charging Data Online': ['chargingData', 'online'],
	'Charging Data Offline': ['chargingData', 'offline'],
	'Charging Data Rating Group': ['chargingData', 'ratingGroup'],
	'Charging Data Service Id': ['chargingData', 'serviceId'],
	'Charging Data Af Charging Identifier': [
		'chargingData',
		'afChargingIdentifier',
	],
	'Charging Data Reporting Level': ['chargingData', 'reportingLevel'],
	'Flow Information Flow': 'hasFlowInfo',
};

export function getNestedField<T>(obj: any, path: string[]): T | undefined {
	return path.reduce((acc, key) => acc?.[key], obj);
}

export function setNestedField<T>(obj: any, path: string[], value: T): any {
	const [key, ...rest] = path;

	if (!key) return value;

	return {
		...obj,
		[key]:
			rest.length > 0 ? setNestedField(obj?.[key] ?? {}, rest, value) : value,
	};
}

export function resolveFieldKey(
	...labels: string[]
): string | string[] | undefined {
	const key = labels.join(' ');
	return labelToFieldMap[key];
}

export function resolveFieldRuleKey(
	...labels: string[]
): string | string[] | undefined {
	const key = labels.join(' ');
	return labelToFieldRuleMap[key];
}
